import { render, staticRenderFns } from "./s3.vue?vue&type=template&id=8c7d0cf6&scoped=true&"
import script from "./s3.vue?vue&type=script&lang=js&"
export * from "./s3.vue?vue&type=script&lang=js&"
import style0 from "./s3.vue?vue&type=style&index=0&id=8c7d0cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d0cf6",
  null
  
)

export default component.exports